import React, {PureComponent} from 'react'
import cn from 'classnames'
import Icon from 'components/common/elements/Icon'
import File from './File'
import Import from './Import/Import'

import './ModalImport.scss';

class ImportModal extends PureComponent {
  constructor() {
    super();
    this.state = {
      isFileUploaded: false,
      data: null,
    };
  }
  handleFileLoad(data) {
    this.setState({
      isFileUploaded: true,
      data,
    });
  }

  render() {
    const { isFileUploaded, data } = this.state;
    const { sequenceId } = this.props;

    return (
      <div className={cn("import-csv-modal", {_isFileUploaded: isFileUploaded})}>
        <span className="gs-modal__hide" role="button" onClick={() => this.props.onRequestClose()}>
          <Icon icon="cross" color="white" size={28}/>
        </span>

        <div className="gs-modal__header">Import from CSV</div>

          <div className="gs-modal__content">
            { !isFileUploaded && <File handleFileLoad={ data => this.handleFileLoad(data) } sequenceId={sequenceId} />}
            { isFileUploaded && <Import data={data} close={this.props.onRequestClose}  sequenceId={sequenceId}/>}
          </div>
      </div>
    )
  }
}

ImportModal.propTypes = {
};

export default ImportModal;
